$(document).ready(function() {
  $('.hamburger').on('click', function() {
    $('body').toggleClass('nav-active')
  })

  $('.header-nav .header-item:first-child, .header-shop').hover(
    function() {
      $('body').addClass('shop-nav-active')
    },
    function() {
      $('body').removeClass('shop-nav-active')
    }
  )
})
